import React from 'react';
import SearchBar from './SearchBar';
import DarkMode from './DarkMode';

const Navbar = () => {
  return (
    <div className="nav-container">
      <nav className="nav-items">
        <p>Stockwatch</p>
        <SearchBar />
        <DarkMode />
      </nav>
    </div>
  );
};

export default Navbar;
